import React from "react";
import Banner from "../Banner/Banner";
import Library from "./Library";
import styles from "./Dashboard.module.css";

const Dashboard = () => {
  return (
    <div className={styles.dashwrapper}>
      <div className={styles.container}>
        <main className={styles.dashboard}>
          <Banner />
          <div className={styles.wrapper}>
            <section className={styles.main}>
              <Library title={"For You"} page={1} />
              <Library title={"Your Library"} page={2} />
              <Library title={"Popular in friends"} page={3} />
              <Library title={"Trending in Turkey"} page={4} />
            </section>
          </div>
        </main>
      </div>
      <div className={styles.fadeOverlay} />
    </div>
  );
};

export default Dashboard;
